<template>
  <div class="certificationInfo">
    <ul class="main" v-if="userInfo">
      <li>
        <div class="main_content" @click="userInfo.isRealname?'':certification(1)">
          <img src="../assets/images/shimingrenzheng.png" alt="">
          <div>
            <div class="title">完成实名认证</div>
            <div class="hint">点击完成实名认证可领取无门槛停车优惠</div>
          </div>
          <button v-if="!userInfo.isRealname">未完成</button>
          <button class="button_success" v-else>已完成</button>
        </div>
        <img class="back" src="../assets/images/renzheng_back.png" alt="">
      </li>
      <li>
        <div class="main_content" @click="userInfo.isDriveCard?'':certification(2)">
          <img src="../assets/images/renzheng_jsz.png" alt="">
          <div>
            <div class="title">驾驶证认证</div>
            <div class="hint">点击完成驾驶证认证可领取无门槛停车优惠</div>
          </div>
          <button v-if="!userInfo.isDriveCard">未完成</button>
          <button class="button_success" v-else>已完成</button>
        </div>
        <img class="back" src="../assets/images/renzheng_back.png" alt="">
      </li>
      <li>
        <div class="main_content" @click="userInfo.isLicense?'':certification(3)">
          <img src="../assets/images/renzheng_xsz.png" alt="">
          <div>
            <div class="title">行驶证认证</div>
            <div class="hint">点击完成行驶证认证可领取无门槛停车优惠</div>
          </div>
          <button v-if="!userInfo.isLicense">未完成</button>
          <button class="button_success" v-else>已完成</button>
        </div>
        <img class="back" src="../assets/images/renzheng_back.png" alt="">
      </li>
    </ul>
  </div>
</template>

<script>
  let wx = require('weixin-js-sdk');
  export default {
    name: "CertificationInfo",
    data:function(){
      return {
        userInfo: {},
        result: ''
      }
    },
    watch: {
      $route(){
        this.result = this.$route.query.result;
      },
      result:function(newVal) {
        this.appCallback(newVal);
      },
    },
    created() {
      this.uid = this.$route.query.uid;
      this.type = this.$route.query.type;
      this.usermsg();
      window['appCallback'] = (result) => {
        this.appCallback(result);
      };
    },
    methods:{


      appCallback:function(result){
        if(result=='1'){
          this.userInfo.isRealname = true
        }else if(result=='2'){
          this.userInfo.isDriveCard = true
        }else if(result=='3'){
          this.userInfo.isLicense = true
        }else{
          this.$toast("传值错误："+result);
        }
      },

      certification:function(status){
        let type = this.type;
        /**
         * 分享至
         * 1:微信
         * 2:朋友圈
         * 3:支付宝
         * 4:微博
         * */
        if(type==='ios'){
          window.webkit.messageHandlers.certificationJump.postMessage({
            status: status
          });
          // window.webkit.messageHandlers.shareThird.postMessage({body: 'hello world!'});
        }else if(type==="android"){
          window.certification.jump(status);
        }else if(type==="wechat"){
          window.console.log(wx.checkJsApi);
          if(wx.checkJsApi){
            if(status == 1){
              wx.miniProgram.navigateTo({
                url:'/pages/realname/realname'
              })
            }else if(status == 2){
              wx.miniProgram.navigateTo({
                url:'/pages/driving_licence/driving_licence'
              })
            }else if(status == 3){
              wx.miniProgram.navigateTo({
                url:'/pages/my_car/my_car'
              })
            }else{
              this.$toast('未知错误');
            }
          }
        }else if(type==="alipay"){
          if(status == 1){
            // eslint-disable-next-line no-undef
            my.navigateTo({
              url:'/pages/realname/realname'
            })
          }else if(status == 2){
            // eslint-disable-next-line no-undef
            my.navigateTo({
              url:'/pages/driving_licence/driving_licence'
            })
          }else if(status == 3){
            // eslint-disable-next-line no-undef
            my.navigateTo({
              url:'/pages/my_car/my_car'
            })
          }else{
            this.$toast('未知错误');
          }
        }else{
          this.$toast('不支持当前设备')
        }
      },

      //查询用户信息
      usermsg:function(){
        let data = {
          base:{
            uid: this.uid
          }
        };
        this.$ajax.post('/caruser/setting/usermsg',data)
          .then(res=>{
            this.userInfo = res.data.data;
            window.console.log(res);
          })
          .catch(error=>{
            window.console.log(error);
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  @function tovw($px) {
    @return $px / 7.5px * 1vw;
  }
  .certificationInfo{
    position: relative;
    height: 100vh;
    width: 100vw;
    background-image: url("../assets/images/renzhenglinghaoli.png");
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-color: #ade5ff;
    .main{
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      padding: tovw(30px) tovw(60px);
      li{
        position: relative;
        width: 100%;
        margin-bottom: 2vh;
        .back{
          width: 100%;
        }
      }
      &_content{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: tovw(42px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 tovw(30px);
        img{
          width: tovw(100px);
          flex-shrink: 0;
        }
        div{
          padding: 0 tovw(10px);
          .hint{
            margin-top: tovw(4px);
            font-size: tovw(24px);
            color: #999;
          }
        }
        button{
          width: tovw(127px);
          height: tovw(60px);
          line-height: tovw(60px);
          border-radius: tovw(30px);
          background-color: #5E76FF;
          color: #fff;
          border: none;
          flex-shrink: 0;
        }
        .button_success{
          opacity: 0.6;
        }
      }
    }
  }
</style>
